<div class="loader-container {{#if full_height}}full-height{{/if}} {{#if is_inline}}inline-z-index{{/if}}">
    <div class="loader-content-container">
        {{#ifCond loader_title '!=' ""}}
        <div class="loader-w" data-i18n="dashboard_loading">Loading...</div>
        <h2 class="h1">{{loader_title}}</h2>
        <h4 class="">{{loader_description}}</h4>
        {{else}}
        <div class="loader-w" data-i18n="dashboard_loading">Loading...</div>
        {{/ifCond}}
    </div>
</div>